export const DOWNLOAD_AUDIO_EVENT = "downloadAudio";

export const DOWNLOAD_AUDIO_TYPES = {
  CONVERSION: "conversion",
  ISOLATION: "isolation",
  HARMONY: "harmony",
  STEM_SPLITTER: "stemSplitter",
} as const;

export const DOWNLOAD_AUDIO_TYPE_VALUES = Object.values(
  DOWNLOAD_AUDIO_TYPES
) as [(typeof DOWNLOAD_AUDIO_TYPES)[keyof typeof DOWNLOAD_AUDIO_TYPES]];
